import Layton121 from '../../../Media/BSD/Navapark/Layton 12.webp'
import Layton122 from '../../../Media/BSD/Navapark/Layton 12.webp'





const Layton12images =[
Layton121,Layton122
]

export default Layton12images;